// eslint-disable-next-line no-shadow
enum Roles {
  KBA = 'KBA',
  DISTRICT_ADMIN = 'DISTRICT_ADMIN',
  SCHOOL_ADMIN = 'SCHOOL_ADMIN',
  TEACHER_ADMIN = 'TEACHER',
}
export default Roles;
